/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailAndName } from './emailAndName';
import { ProductionRecord } from './productionRecord';
import { BatchDevice } from './batchDevice';
import { Change } from './change';


export interface BatchDto { 
    prioNo: number;
    configNo: number;
    fakturaId: string;
    deviceTypeId: string;
    deviceTypeName: string;
    comType: BatchDto.ComTypeEnum;
    manufacturingStatus: BatchDto.ManufacturingStatusEnum;
    totalAmount: number;
    assigned?: Array<BatchDevice>;
    airtimeStatus?: string;
    orderItemConfigurationId: string;
    assemblers?: Array<EmailAndName>;
    dueDate?: string;
    productionDate?: string;
    ticketIds?: Array<number>;
    unconfirmedChanges?: Array<Change>;
    orderId: string;
    orderItemId: number;
    productionStopped?: boolean;
    dropOffType?: BatchDto.DropOffTypeEnum;
    hasConfirmedAirtimeAccountWithAgreement: boolean;
    airtimeAccountName?: string;
    airtimeAccountNumber?: number;
    airtimeAccountFakturaCustomerRefNo?: number;
    airtimeAccountOwners?: Array<EmailAndName>;
    dataPlan?: BatchDto.DataPlanEnum;
    productionRecord: ProductionRecord;
    batteryTypeName?: string;
    cancellationConfirmed?: boolean;
    refurbishments?: Array<string>;
}
export namespace BatchDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const ManufacturingStatusEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type ManufacturingStatusEnum = typeof ManufacturingStatusEnum[keyof typeof ManufacturingStatusEnum];
    export const DropOffTypeEnum = {
        Internal: 'INTERNAL',
        External: 'EXTERNAL',
        Both: 'BOTH'
    } as const;
    export type DropOffTypeEnum = typeof DropOffTypeEnum[keyof typeof DropOffTypeEnum];
    export const DataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanEnum = typeof DataPlanEnum[keyof typeof DataPlanEnum];
}


export type DropOffTypeEnum = typeof BatchDto.DropOffTypeEnum[keyof typeof BatchDto.DropOffTypeEnum];
